import './Store.scss';
import Component from './Store.js';
export default Component;
